<template>
  <TimeConstraintList :constrainedItem="currentTrack" :timeConstraintType="timeConstraintType"/>
</template>
<script>
import { mapState, mapMutation } from "vuex";
import TimeConstraintList from "@/components/common/TimeConstraintList";
import TimeConstraintApis from "@/apis/_apiTimeConstraints";
export default {
  components: { TimeConstraintList },
  computed: {
    ...mapState("tracks", ["currentTrack"])
  },
  data() {
    return {
      viewState: {
        showNewPanel: false
      },
      timeConstraintType: TimeConstraintApis.TIME_CONSTRAINT_TYPES.MEDIA.value
    };
  },
};
</script>